import { styles, variants, WindowOverlayTheme } from '../WindowOverlayStyles.css';
import { baseTheme } from './WindowOverlayBaseTheme.css';
import { multiVariantStyles } from './WindowOverlayVariants.css';

/*******************
 * Component Theme
 *******************/

const WindowOverlayStableTheme: WindowOverlayTheme = {
  baseTheme,
  multiVariantStyles,
  variants,
  styles
};

/*******************
 * Exports
 *******************/

export { WindowOverlayStableTheme };
